import { render, staticRenderFns } from "./ModeloDocumento.vue?vue&type=template&id=64b744bf"
import script from "./ModeloDocumento.vue?vue&type=script&lang=js"
export * from "./ModeloDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModeloDocumento.vue?vue&type=style&index=0&id=64b744bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports